import React, {useCallback, useEffect, useState} from 'react';
import {toast} from 'react-toastify';
import BasicButton from '../../../../components/BasicButton';
import FiltersContentLoader from '../../../../components/FiltersContentLoader';
import ENDPOINT from '../../../../constants/endpoints';
import useApi from '../../../../hooks/useApi';
import './styles.css';

const CandidateNotesWidget = ({ candidateId, isEdit }) => {
  const [note, setNote] = useState('');
  const [updatedAt, setUpdatedAt] = useState(null);
  const api = useApi();
  const [formLoading, setFormLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  const save = useCallback(() => {
    setFormLoading(true);

    api.postRequest(ENDPOINT.ENTITY.CANDIDATE_NOTE, { candidateId, note }, {
      handleSuccess: () => {
        toast.success('Note saved');
      },
      handleComplete: () => {
        setFormLoading(false);
      },
      handleError: (e) => {
        if (e && e.data.message) {
          toast.error(e.data.message);
        } else {
          toast.error('Internal error');
        }
      }
    });
  }, [note, candidateId]);

  const onChange = useCallback((e) => {
    setNote(e.target.value);
  }, []);

  useEffect(() => {
    api.getRequest(ENDPOINT.ENTITY.CANDIDATE_NOTE, { candidateId }, {
      handleSuccess: (response) => {
        setLoading(false);

        if (!response) {
          return;
        }

        setNote(response.note);
        setUpdatedAt(response.updatedAt);
      },
      handleError: () => {
        setLoading(false);
      }
    });
  }, []);

  if (loading) {
    return <FiltersContentLoader />;
  }

  if (!loading && !isEdit && !note) {
    return null;
  }

  return (
    <div className={'sidebar__widget candidate-notes'}>
      <h3 className={'sidebar__title'}>Candidate Bio</h3>
      {!isEdit && (
        <div className={'candidate-notes__content'}>
          <div className={'candidate-notes__text'}>{note}</div>
          <div className={'candidate-notes__updated-at'}>Last updated: {updatedAt}</div>
        </div>
      )}
      {isEdit && (
        <div className={'candidate-notes__form'}>
          <textarea onChange={onChange} value={note} />
          <BasicButton
            btnWidth={150}
            btnHeight={35}
            btnFontSize="0.8571rem"
            btnFontWeight={600}
            btnText={'Save'}
            btnArrow={false}
            btnBg="#fff"
            btnHoverBg="#f40"
            controlFunc={save}
            disabled={formLoading}
          />
        </div>
      )}
    </div>
  )
};

export default CandidateNotesWidget;
